import { REDUCER_NAME } from './const'

const NS = REDUCER_NAME + '/'

export const FIND_UNASSIGNED_CASE_LIST_REQUEST = NS + 'FIND_UNASSIGNED_CASE_LIST_REQUEST'
export const FIND_UNASSIGNED_CASE_LIST_SUCCESS = NS + 'FIND_UNASSIGNED_CASE_LIST_SUCCESS'
export const FIND_UNASSIGNED_CASE_LIST_ERROR = NS + 'FIND_UNASSIGNED_CASE_LIST_ERROR'



// WEBPACK FOOTER //
// ./src/modules/threeshape/state/match/type.js